export default __webpack_public_path__ + "static/media/phantom-icon.3352c9c1.png";